import { EditableFieldWrapper } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SEditableFieldWrapper = styled(EditableFieldWrapper)``;
